export const SET_FILTERS = 'Orders/SET_FILTERS';

export const FETCH_ORDERS_REQUEST = 'Orders/FETCH_ORDERS_REQUEST';
export const FETCH_ORDERS_SUCCESS = 'Orders/FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_ERROR = 'Orders/FETCH_ORDERS_ERROR';

export const DOWNLOAD_FILE_REQUEST = 'Orders/DOWNLOAD_FILE_REQUEST';
export const DOWNLOAD_FILE_SUCCESS = 'Orders/DOWNLOAD_FILE_SUCCESS';
export const DOWNLOAD_FILE_ERROR = 'Orders/DOWNLOAD_FILE_ERROR';
